const carouselItems = [
  {
    img: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20romance%20manhwa%20illustration%20with%20two%20characters%20in%20a%20cherry%20blossom%20scene%2C%20soft%20pastel%20warm%20colors%2C%20emotional%20atmosphere%2C%20delicate%20line%20art%2C%20webtoon%20style%2C%20romantic%20mood%2C%20dreamy%20lighting%2C%20spring%20season%20background&width=800&height=500&seq=carousel-manga-01&orientation=landscape',
    tag: '热门韩漫',
    title: '恋爱幻想曲',
    desc: '当命运的红线牵起两个世界的灵魂，一场跨越时空的浪漫冒险就此展开。画风唯美，剧情扣人心弦。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Japanese%20manga%20fantasy%20battle%20scene%20with%20magical%20effects%20and%20floating%20energy%20orbs%2C%20warm%20golden%20and%20amber%20color%20palette%2C%20epic%20composition%2C%20detailed%20character%20design%2C%20shonen%20style%2C%20dramatic%20lighting%2C%20action%20pose&width=800&height=500&seq=carousel-manga-02&orientation=landscape',
    tag: '人气日漫',
    title: '魔导纪元',
    desc: '少年意外觉醒远古魔力，踏上寻找失落文明的冒险之旅。热血战斗与深厚友情交织，卷卷精彩。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20cultivation%20fantasy%20scene%20with%20floating%20mountains%20and%20ancient%20temples%2C%20warm%20sunset%20lighting%2C%20mystical%20atmosphere%2C%20traditional%20Chinese%20ink%20painting%20influence%2C%20flowing%20robes%2C%20ethereal%20clouds%2C%20golden%20hour%20glow&width=800&height=500&seq=carousel-manga-03&orientation=landscape',
    tag: '精品国漫',
    title: '仙途无尽',
    desc: '凡尘少年偶得仙缘，一步步攀登修真巅峰。国风水墨交融现代漫画技法，每一帧都是壁纸级画面。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=A%20mysterious%20fantasy%20library%20scene%20with%20floating%20books%20and%20magical%20light%20particles%2C%20warm%20amber%20and%20gold%20tones%2C%20enchanting%20atmosphere%2C%20ancient%20bookshelves%2C%20soft%20glowing%20orbs%2C%20whimsical%20manga%20style%2C%20mystical%20and%20cozy%20vibe&width=800&height=500&seq=carousel-manga-04&orientation=landscape',
    tag: '奇幻推荐',
    title: '书灵奇缘',
    desc: '古籍管理员意外发现书中世界真实存在，每翻开一本书就是一次奇妙冒险。想象力炸裂的奇幻佳作。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=A%20slice%20of%20life%20manga%20scene%20in%20a%20cozy%20cafe%20with%20warm%20sunlight%20streaming%20through%20windows%2C%20characters%20enjoying%20tea%20and%20pastries%2C%20relaxed%20atmosphere%2C%20gentle%20color%20palette%20of%20cream%20and%20soft%20browns%2C%20healing%20and%20comforting%20mood&width=800&height=500&seq=carousel-manga-05&orientation=landscape',
    tag: '治愈日常',
    title: '咖啡馆奇妙夜',
    desc: '深夜咖啡馆里，每位客人都带着自己的故事。温暖治愈的都市日常，让人在忙碌中找到片刻宁静。',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">热门专题</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">精选五大热门漫画专题，发现你的下一部必追神作</p>
        </div>
        <div className="flex flex-wrap justify-center gap-6">
          {carouselItems.map((item) => (
            <div key={item.title} className="w-full sm:w-[calc(50%-12px)] lg:w-[calc(33.333%-16px)] xl:w-[calc(20%-19.2px)] bg-background-100 rounded-2xl overflow-hidden border border-background-200/60 flex flex-col min-w-[250px]">
              <div className="relative w-full aspect-[8/5] overflow-hidden">
                <img
                  src={item.img}
                  alt={`${item.tag} - ${item.title}`}
                  className="w-full h-full object-cover"
                />
                <span className="absolute top-3 left-3 px-3 py-1 bg-primary-500/90 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="font-heading text-base text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}